interface ImageMap {
    [key: string]: string;
}

// no localized image for hu, it, ko, nl, pl, zh
const devOpsSectionImageMap: ImageMap = {
    de: "https://wac-cdn.atlassian.com/dam/jcr:a0b944ea-1046-4d41-a92d-5c90ec1d4fc7/devops-diagram-compressed.png?cdnVersion=1234",
    es: "https://wac-cdn.atlassian.com/dam/jcr:5c9e9577-c614-409b-9a77-6066cd098fd0/devops-diagram-compressed.png?cdnVersion=1234",
    fr: "https://wac-cdn.atlassian.com/dam/jcr:29249a01-930d-4581-817d-e6a5a2fc7ee5/devops-diagram-compressed.png?cdnVersion=1234",
    br: "https://wac-cdn.atlassian.com/dam/jcr:40ae976e-4ce9-4b16-a0b1-b03d5c513afb/devops-diagram-compressed.png?cdnVersion=1234",
    en: "https://wac-cdn.atlassian.com/dam/jcr:7eb430e2-e868-4f2d-973d-b5d6314e3d8d/devops-diagram-compressed.png?cdnVersion=1195",
    ja: "https://wac-cdn.atlassian.com/dam/jcr:9107fd14-0119-4612-898a-91f1b28cc5a2/devops-diagram-compressed.png?cdnVersion=1232",
    ru: "https://wac-cdn.atlassian.com/dam/jcr:d8679854-700d-43b6-8666-011568c3fe88/devops-diagram-compressed.png?cdnVersion=1234"
};

// no localized image for hu, it, ko, nl, pl, zh
const heroSectionImageMap: ImageMap = {
    de: "https://wac-cdn.atlassian.com/dam/jcr:a0aa83d8-cae8-40e5-8e08-d08072005fad/hero-illustration%20(1).png?cdnVersion=1234",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Hero.webp",
    es: "https://wac-cdn.atlassian.com/dam/jcr:2364d326-6464-409e-b218-faad35118be4/hero-illustration%20(1).png?cdnVersion=1234",
    fr: "https://wac-cdn.atlassian.com/dam/jcr:4968f3cd-2b82-41ef-9dac-e5057dd324f0/hero-illustration%20(1).png?cdnVersion=1234",
    ja: "https://wac-cdn.atlassian.com/dam/jcr:f1f2c4a5-2899-42f9-8f61-00aba6f0f1ff/hero-illustration%20(1).png?cdnVersion=1232",
    br: "https://wac-cdn.atlassian.com/dam/jcr:3fb66ce1-2dc1-4b17-99b6-cf366afcface/hero-illustration%20(1).png?cdnVersion=1234",
    ru: "https://wac-cdn.atlassian.com/dam/jcr:e32254d7-5bef-4ffa-adae-0192c1d98074/hero-illustration%20(1).png?cdnVersion=1234"
};

// no localized images available for the placeholder image for the plan tab video
const planTabsSectionImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:49c215de-3b05-40f8-96e2-6dc65c70caa6/Board.png?cdnVersion=1187"
};

// no localized image for hu, it, ko, nl, pl, zh
const planTabsSectionVideoMap: ImageMap = {
    en: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/JSW-Plan.mp4",
    ja: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/JA/JSW-Plan-JA.mp4",
    de: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/DE/JSW-Plan-DE.mp4",
    es: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/ES/JSW-Plan-ES.mp4",
    fr: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/FR/JSW-Plan-FR.mp4",
    br: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/PT/JSW-Plan-PT-BR.mp4",
    ru: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-software/RU/JSW-Plan-RU.mp4"
};

// no localized images available
const trackTabsSectionImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:7adc5875-52b0-4fa5-bcd0-c24daa205d0d/Timeline.png?cdnVersion=1192"
};

// no localized images available
const releaseTabsSectionImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:709971e1-5536-4739-8e44-e38541091e9a/Releases.png?cdnVersion=1192"
};

// no localized images available
const reportTabsSectionImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:3a0e3680-c9a9-4b9d-bb63-fe5995db85f3/Insights.png?cdnVersion=1192"
};

// no localized images available
const automateTabsSectionImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:16dcb91e-8263-4ea8-91af-a8eedfc99700/Automation.png?cdnVersion=1192"
};

// no localized image for hu, it, ko, nl, pl, zh
const workflowSectionImageMap: ImageMap = {
    de: "https://wac-cdn.atlassian.com/dam/jcr:13006b4d-1461-4392-a11a-4bcf6e086788/workflow.png?cdnVersion=1234",
    es: "https://wac-cdn.atlassian.com/dam/jcr:7b3d5b36-147c-49ea-9ee6-8de21ea19059/workflow.png?cdnVersion=1234",
    fr: "https://wac-cdn.atlassian.com/dam/jcr:58f20760-b605-4378-b53b-17c9fdb77b3b/workflow.png?cdnVersion=1234",
    br: "https://wac-cdn.atlassian.com/dam/jcr:381387d5-6e0b-46d6-9c38-eda6e193adc9/workflow.png?cdnVersion=1234",
    ru: "https://wac-cdn.atlassian.com/dam/jcr:22282735-3e16-4e41-9f0d-90af8d47485d/workflow.png?cdnVersion=1234",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Workflow.webp",
    ja: "https://wac-cdn.atlassian.com/dam/jcr:9f4579ac-d22e-4714-b793-6d5aae4ad49e/workflow.png?cdnVersion=1232"
};

export const getDevOpsSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return devOpsSectionImageMap[locale] || devOpsSectionImageMap["en"]!;
};

export const getHeroSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return heroSectionImageMap[locale] || heroSectionImageMap["en"]!;
};

export const getPlanTabsSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return planTabsSectionImageMap[locale] || planTabsSectionImageMap["en"]!;
};

export const getPlanTabsSectionVideo = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return planTabsSectionVideoMap[locale] || planTabsSectionVideoMap["en"]!;
};

export const getTrackTabsSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return trackTabsSectionImageMap[locale] || trackTabsSectionImageMap["en"]!;
};

export const getReleaseTabsSectionImage = (locale: string): string => {
    return (
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        releaseTabsSectionImageMap[locale] || releaseTabsSectionImageMap["en"]!
    );
};

export const getReportTabsSectionImage = (locale: string): string => {
    return (
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        reportTabsSectionImageMap[locale] || reportTabsSectionImageMap["en"]!
    );
};

export const getAutomateTabsSectionImage = (locale: string): string => {
    return (
        automateTabsSectionImageMap[locale] ||
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        automateTabsSectionImageMap["en"]!
    );
};

export const getWorkflowSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return workflowSectionImageMap[locale] || workflowSectionImageMap["en"]!;
};
